export function formatGender(T, gender = '') {
  switch (gender) {
    case 'male':
      return T('male');
    case 'female':
      return T('female');
    default:
      return T('no preference');
  }
}
